var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{'down': _vm.loadType=='down'}},[_c('div',{staticClass:"loading-contain"},[_c('div',{staticClass:"loading"}),_c('div',[_vm._v(_vm._s(_vm.$t('common.loadingMsg')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }